import { useState } from 'react'
import { axiosUser } from '../../Utils/axios';
import { swal2 } from '../../Utils/Swal_helper';
import useProfileContext from '../ContextHooks/General/useProfileContext';

function useUpdateData() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [ errorMessage, setErrorMessage ] = useState(null);
  const [ updateSuccess, setUpdateSuccess ] = useState(false);
  const {profileUpdated,setProfileUpdated} = useProfileContext()
  const update = async (route, formData) => {
    setUpdateSuccess(false);

    try {
      setLoading(true);
      setUpdateSuccess(false);

      await axiosUser.put(route, formData).then((response) => {
        setUpdateSuccess(false);
        setLoading(false);

        if (response.status === 200) {
          setUpdateSuccess(false);

          if (response.data.success) {
            setUpdateSuccess(true);
            
            swal2.Toast.fire({
              title: "Successfully updated!",
              icon: "success",
              position: "top-right",
              timerProgressBar: true,
              timer: 3500,
            });
            
            setProfileUpdated(!profileUpdated)
          } else {
            // console.log("error", response)
            setError(true);
            setUpdateSuccess(false);

            swal2.Toast.fire({
              title: response.data.message,
              icon: "error",
              position: "top-right",
              timerProgressBar: true,
              timer: 3500,
            });

            setErrorMessage(response.data.message);
          }
        } else {
          setError(true);
          setUpdateSuccess(false);

          setErrorMessage(response.data.message);
        }
      });
    } catch (err) {
      setUpdateSuccess(false);
      setError(true);
      setErrorMessage(err);
    }
  };
  
  return { update, updateSuccess, loading, error, errorMessage }
  
}

export default useUpdateData